import IndexPageLayout from "..\\..\\..\\..\\src\\templates\\index-page-layout";
import Heading from "..\\..\\..\\..\\src\\controls\\heading-control";
import MainContent from "..\\..\\..\\..\\src\\components\\main-content";
import FeaturedImage from "..\\..\\..\\..\\src\\components\\featured-image";
import BigSearch from "..\\..\\..\\..\\src\\controls\\big-search-control";
import HomeParagraph from "..\\..\\..\\..\\src\\controls\\home-paragraph-control";
import AuxiliaryContent from "..\\..\\..\\..\\src\\components\\auxiliary-content";
import Footer from "..\\..\\..\\..\\src\\components\\footer";
import { InlineLinkDarkControl as InlineLink } from "..\\..\\..\\..\\src\\controls\\inline-link-control";
import HomeReadMore from "..\\..\\..\\..\\src\\controls\\home-read-more";
import * as React from 'react';
export default {
  IndexPageLayout,
  Heading,
  MainContent,
  FeaturedImage,
  BigSearch,
  HomeParagraph,
  AuxiliaryContent,
  Footer,
  InlineLink,
  HomeReadMore,
  React
};